export default {
  name: {
    substitutes: {
      unknown: 'enseigne inconnue',
      invalid: 'image invalide',
      glass: 'scan de verre'
    }
  }
}
